export const language_list = [
	{ 'value': 'EN', 'display': 'English' },
	{ 'value': 'ES', 'display': 'Español' },
	{ 'value': 'BR', 'display': 'Portugues(Brasil)' },
	{ 'value': 'THAI', 'display': 'ไทย' },
	{ 'value': 'BAH', 'display': 'Bahasa(Indonesia)' },
	{ 'value': 'VN', 'display': 'Tiếng Việt' },
	{ 'value': 'CH', 'display': '中文(简体字)' },
	{ 'value': 'HK', 'display': '中文(繁體字 香港)' },
	{ 'value': 'TW', 'display': '中文(繁體字 台灣)' },
	{ 'value': 'JP', 'display': '日本語' }
];